import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL

const AuthService = {
  state: {
    user: JSON.parse(localStorage.getItem('user')) || '',
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    init_state (state, payload) {
      state.token = payload.token
      state.user = payload.user
    },
    reset_user (state, payload) {
      state.user = payload.user
    },
    empty_state (state) {
      state.token = ''
      state.user = ''
    }
  },
  actions: {
    login ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/login',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            const user = resp.data.user
            const token = resp.data.access_token
            localStorage.setItem('token', token)
            localStorage.setItem('user', JSON.stringify(user))
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            commit('api_success')
            commit('init_state', { token, user })
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    signup ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/signup',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    logout ({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/logout',
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            dispatch('logoutUserFromApp')
            resolve()
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    logoutUserFromApp ({ dispatch, commit }) {
      commit('empty_state')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
    },
    isUserLoggedIn ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        axios({
          url: BASE_URL + '/user',
          method: 'GET'
        })
          .then(resp => {
            if (!resp.data.logged_in) {
              dispatch('logoutUserFromApp')
            } else {
              localStorage.setItem('user', JSON.stringify(resp.data.user))
              commit('reset_user', {user: resp.data.user})
            }
            resolve(resp)
          })
          .catch(err => {
            dispatch('logoutUserFromApp')
            reject(err)
          })
      })
    },
    verifyEmail ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/email/verification/' + data.id + '/' + data.hash + '?' + data.queryParams,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            localStorage.setItem('user', JSON.stringify(resp.data.user))
            commit('reset_user', {user: resp.data.user})
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    verifyEmailRequest ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/verify/email',
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchInstagramFeed ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/instagram/feed',
          data: data,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchTweets ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/tweets',
          data: data,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchSpotifyAlbums ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/spotify/albums',
          data: data,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchAllReleases ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/releases',
          data: data,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchLatestBlogs ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/blogs/latest',
          data: data,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchHomepageBanners ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/homepage-banners',
          data: data,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchLatestYoutubeBanner ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/youtube-banner/' + data.type + '/latest',
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchYoutubeMusics ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/musics',
          data: data,
          method: 'GET',
          headers: {
            'Range': 'bytes=0-'
          }
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    submitContactQuery ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/query',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    submitSubmission ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/submission',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    submitNewsLetter ({ commit, dispatch }, data) {
      console.log(data.subscribe_to)
      data.subscribe_to = data.subscribe_to.join(', ')
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/newsletter',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isEmailVerified: state => !!state.user.email_verified_at,
    getToken: state => state.token,
    user: state => state.user
  }
}

export default AuthService



// WEBPACK FOOTER //
// ./src/services/userService.js